export default defineNuxtPlugin((nuxtApp) => {
    let isLexerLoaded = false

    const initLexer = () => {
        if (isLexerLoaded) return

        type LxtFunction = (...args: any[]) => void;

        window.__lxt_cache = window.__lxt_cache || [];

        const lxt: LxtFunction = function() {
            window.__lxt_cache.push(arguments);
        }

      // Define attributes
      window.lxt_attributes = {
        products_removed_from_wishlist: "46e36ccbd2b042769947f3a743359d6a",
        products_added_to_wishlist: "38f3794ff80e4650ba608864e8799802",
        email: "bb1a9f05a09d4983b47feafb11733e3e",
        categories_viewed: "544084aa557f4d8b9f9f0a774628b7ba",
        date_of_last_visit: "22679b3122cc4757a9b23424651164ce",
        dates_visited: "d69e03c065604d7f953d276dc10df8a5",
        device_used: "d81be5bf5626478d843712e39c2f8bf1",
        did_complete_conversion: "290090948811421abd42768907694bc2",
        did_start_conversion: "60bd4083f9e445a7a90d06e235c717a9",
        pages_viewed_to_convert: "27c4107546a241198d78613a8846e7e7",
        products_added_to_cart: "a0c8885614b34aedb00ac69571e2b09a",
        products_removed_from_cart: "ebc9294b8fd1450e88afb701ff9fe871",
        products_viewed: "d580f383d16644cb9b11a4cf062580f1",
        referrer_url: "5ee6411d9a7b4ab8a351e001eaf1c226",
        time_spent_to_convert: "788b2d732f7e444d8e0f93d11890276c",
        utm_campaign: "9cfb1561ff284e90a34ab7027c21fe09",
        utm_content: "1c6a917c7d8749eeac87a6b3ed160c18",
        utm_medium: "86ebe8840fee4de59dce31c2232997cc",
        utm_source: "17e8b0f0361d4d3d846905cff23bf798",
        utm_term: "685b454eb59a407bb03ebc797ba8f6dd",
        email_sha256: "3d98c66152d546068205915b81026367"
      };

      // Initialize Lexer
      lxt("initiate", "bc60862b10c44ece9c0edd68d4340448", window.lxt_attributes);

      // Load Lexer script
      const script = document.createElement('script');
      script.src = 'https://tag.lexer.io/lxt.js';
      script.async = true;
      script.onload = () => {
        trackLexerInit();
      }
      document.head.appendChild(script);

      isLexerLoaded = true;
    }

    const trackLexerInit = () => {
        const isLocalStorageAvailable = () => {
            var test = 'test';
            try {
                localStorage.setItem(test, test);
                localStorage.removeItem(test);
                return true;
            } catch (e) {
                return false;
            }
        }

        const lxer_date = () => {
            return new Date().toISOString().substring(0, 10) + "T00:00:00.140Z";
        }

        if (typeof lxt != 'undefined') {
            console.log('Lexer Tracking: Start Session');
            if (isLocalStorageAvailable()) {
                let date_of_last_visit = localStorage.getItem("date_of_last_visit");

                if (!date_of_last_visit) {
                date_of_last_visit = lxer_date();
                }

                localStorage.setItem("date_of_last_visit", lxer_date());
                lxt('track', 'date_of_last_visit', date_of_last_visit);
            }

            lxt('track', 'dates_visited', lxer_date());

            console.warn('Lexer Track', "lxt('track', 'did_start_conversion', true)");
            lxt('track', 'did_start_conversion', true);
        }
    }

    const loadLexerWithDelay = () => {
        if (process.client) {
            // Detect mobile/desktop
            const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

            if (isMobile) {
            // For mobile: Load on first touch
            document.addEventListener('touchstart', () => {
                initLexer();
            }, { once: true });
            } else {
            // For desktop: Load on mousemove
            document.addEventListener('mousemove', () => {
                initLexer();
            }, { once: true });
            }
        }
    }

    // Initialize when app is mounted
    nuxtApp.hook('app:mounted', () => {
        loadLexerWithDelay();
    });
  });